/* =========================================================================
   Maisonware theme JS
   Cart uses the Shopify AJAX Cart API plus the Section Rendering API, so the
   drawer markup stays in Liquid rather than being rebuilt in JavaScript.
   ========================================================================= */
(function () {
  'use strict';

  var routes = window.MWRoutes || {};
  var strings = window.MWStrings || {};

  /* ---------------------------------------------------------- utilities */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = window.MWMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/, whole);
  }

  /* ---------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg class="icon"><use href="#ui-check"></use></svg><span>' + msg + '</span>';
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------------------------------------------------------- drawer */
  function openDrawer() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    var o = $('.overlay'); if (o) o.classList.add('show');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.modal.open')) { var o = $('.overlay'); if (o) o.classList.remove('show'); }
    document.body.classList.remove('no-scroll');
  }

  /* ---------------------------------------------------------- cart state */
  function refreshDrawer() {
    // Section Rendering API — re-render the drawer from Liquid
    return fetch(routes.cart + '?section_id=cart-drawer-section', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-drawer-contents]');
          var target = $('[data-drawer-contents]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        }
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(updateCounts)
      .catch(function () { return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(updateCounts); });
  }

  function updateCounts(cart) {
    if (!cart) return cart;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-count-bubble]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    updateShipNote(cart.total_price);
    return cart;
  }

  function updateShipNote(total) {
    var threshold = window.MWFreeShipThreshold || 0;
    if (!threshold) return;
    var left = threshold - total;
    $$('[data-ship-note]').forEach(function (el) {
      el.textContent = left > 0
        ? 'Add ' + formatMoney(left) + ' for free delivery'
        : 'Free delivery applied';
    });
  }

  function addToCart(formData, feedbackLabel) {
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add that item');
          return;
        }
        toast(feedbackLabel || strings.added || 'Added to your bag');
        return refreshDrawer().then(function () {
          if (document.body.dataset.cartDrawer !== 'off') openDrawer();
        });
      })
      .catch(function () { toast('Something went wrong. Please try again.'); });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshDrawer();
      });
  }

  /* ---------------------------------------------------------- variants */
  function initProductForm() {
    var form = $('#ProductForm');
    var json = $('[data-product-json]');
    if (!form || !json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    var qty = 1;
    var qtyInput = $('[data-qty-input]', form);
    var qtyVals = $$('[data-pdp-qty-val]');

    $$('[data-pdp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, qty + parseInt(b.getAttribute('data-pdp-qty'), 10));
        qtyVals.forEach(function (el) { el.textContent = qty; });
        if (qtyInput) qtyInput.value = qty;
      });
    });

    function selectedOptions() {
      return $$('[data-option-index]').map(function (group) {
        var pressed = group.querySelector('[aria-pressed="true"]');
        return pressed ? pressed.getAttribute('data-option-value') : null;
      });
    }

    function matchVariant() {
      var chosen = selectedOptions();
      if (!chosen.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] !== null && v.options[j] !== chosen[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function apply() {
      var v = matchVariant();
      var idField = $('[data-variant-id]', form);
      var atc = $('[data-atc]', form);
      var priceRow = $('[data-price-row]');

      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idField) idField.value = v.id;

      if (priceRow) {
        var html = '<span class="now">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="was">' + formatMoney(v.compare_at_price) + '</span>';
          html += '<span class="save-pill">Save ' + formatMoney(v.compare_at_price - v.price) + '</span>';
        }
        priceRow.innerHTML = html;
      }

      if (atc) {
        atc.disabled = !v.available;
        atc.innerHTML = (v.available ? 'Add to bag' : (strings.soldOut || 'Sold out')) +
          '<svg class="icon"><use href="#ui-arrow"></use></svg>';
      }

      var sPrice = $('[data-sticky-price]');
      if (sPrice) sPrice.textContent = formatMoney(v.price);
      var sCompare = $('[data-sticky-compare]');
      if (sCompare) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        sCompare.textContent = onSale ? formatMoney(v.compare_at_price) : '';
        sCompare.hidden = !onSale;
      }
      var sVariant = $('[data-sticky-variant]');
      if (sVariant) sVariant.textContent = v.title;
      var sBtn = $('[data-sticky-atc]');
      if (sBtn) {
        sBtn.disabled = !v.available;
        sBtn.innerHTML = (v.available ? 'Add to bag' : (strings.soldOut || 'Sold out')) +
          '<svg class="icon"><use href="#ui-arrow"></use></svg>';
      }

      if (v.featured_media) selectMediaById(v.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-option-index]').forEach(function (group, gi) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('[data-option-value]');
        if (!b) return;
        $$('[data-option-value]', group).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var label = document.querySelector('[data-option-label="' + (gi + 1) + '"]');
        if (label) label.textContent = b.getAttribute('data-option-value');
        apply();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(new FormData(form));
    });

    var sticky = $('[data-sticky-atc]');
    if (sticky) sticky.addEventListener('click', function () { addToCart(new FormData(form)); });

    // Sticky add to bag: appears once the main button has scrolled past, and
    // retreats near the footer so it never sits on top of the last section.
    var atcRow = $('.atc-row'), bar = document.getElementById('sticky-atc');
    if (atcRow && bar) {
      var footer = document.querySelector('.site-footer');
      var queued = false;
      function evaluate() {
        queued = false;
        var scrolledPast = atcRow.getBoundingClientRect().bottom < 0;
        var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
        var show = scrolledPast && !atFooter;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      function queue() { if (!queued) { queued = true; requestAnimationFrame(evaluate); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      queue();
    }
  }


  /* ---------------------------------------------------------- discounts
     Shopify has no AJAX endpoint for applying a discount code. /discount/CODE
     is the supported route: it stores the code against the cart session and
     carries it to checkout. Order-level discounts then show in the cart; some
     types (shipping-only, for instance) only resolve at checkout, so we never
     claim a code is invalid — Shopify gives us no way to tell.              */
  function applyDiscount() {
    var input = $('[data-discount-input]');
    var msg = $('[data-discount-msg]');
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      if (msg) { msg.textContent = 'Enter a code first.'; msg.className = 'fine discount-msg is-warn'; }
      return;
    }

    var btn = $('[data-discount-apply]');
    if (btn) { btn.disabled = true; }
    if (msg) { msg.textContent = 'Applying…'; msg.className = 'fine discount-msg'; }

    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        if (btn) btn.disabled = false;
        // Re-query: refreshDrawer replaced the markup
        var freshMsg = $('[data-discount-msg]');
        var applied = $('.applied-discounts');
        var panel = $('[data-discount-panel]');
        var toggle = $('[data-discount-toggle]');
        if (panel) { panel.hidden = false; }
        if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
        if (freshMsg) {
          if (applied) {
            freshMsg.textContent = 'Discount applied.';
            freshMsg.className = 'fine discount-msg is-ok';
          } else {
            freshMsg.textContent = 'Code saved. It will be applied at checkout if it qualifies.';
            freshMsg.className = 'fine discount-msg';
          }
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        var m = $('[data-discount-msg]');
        if (m) { m.textContent = 'Could not apply that right now. Try again at checkout.'; m.className = 'fine discount-msg is-warn'; }
      });
  }

  /* ---------------------------------------------------------- gallery
     Kept separate from the product form on purpose: if the variant JSON
     ever fails to parse, the gallery must still work.                   */
  function showMedia(btn) {
    var main = document.getElementById('MainProductImage');
    if (!main || !btn) return;
    var src = btn.getAttribute('data-src');
    if (!src) return;

    // srcset must be updated too — the browser picks from srcset and
    // ignores src, so setting src alone changes nothing on screen.
    main.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
    main.setAttribute('src', src);
    main.setAttribute('alt', btn.getAttribute('data-alt') || '');

    $$('[data-thumb]').forEach(function (x) {
      var on = x === btn;
      x.classList.toggle('active', on);
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function selectMediaById(id) {
    if (!id) return;
    var btn = document.querySelector('[data-thumb][data-media-id="' + id + '"]');
    if (btn) showMedia(btn);
  }

  function initGallery() {
    var thumbs = $$('[data-thumb]');
    if (!thumbs.length) return;

    // Delegated, so it survives any re-render of the gallery
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) { e.preventDefault(); showMedia(t); }
    });

    // Left/right arrows move through the gallery
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var current = document.querySelector('[data-thumb].active');
      if (!current || document.activeElement.closest('.pdp-thumbs') === null) return;
      var list = $$('[data-thumb]');
      var i = list.indexOf(current);
      var next = list[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (next) { showMedia(next); next.focus(); }
    });
  }

  /* ---------------------------------------------------------- reveal + header */
  var ticking = false, headerEl;
  function sweep() {
    ticking = false;
    if (!headerEl) headerEl = $('[data-header]');
    if (headerEl) {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      headerEl.classList.toggle('is-stuck', y > 24);
    }
    var vh = window.innerHeight;
    $$('.reveal:not(.in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('in');
    });
  }
  function queueSweep() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }

  /* ---------------------------------------------------------- popup */
  function popupSeen() { try { return localStorage.getItem('mw_popup') === '1'; } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem('mw_popup', '1'); } catch (e) {} }
  function openModal() {
    var m = $('[data-popup]');
    if (!m || popupSeen()) return;
    m.classList.add('open');
    var o = $('.overlay'); if (o) o.classList.add('show');
    markSeen();
  }
  function closeModal() {
    var m = $('[data-popup]');
    if (!m) return;
    m.classList.remove('open');
    if (!$('.drawer.open')) { var o = $('.overlay'); if (o) o.classList.remove('show'); }
  }

  /* ---------------------------------------------------------- boot */
  function boot() {
    if ('requestAnimationFrame' in window) document.documentElement.classList.add('js');

    document.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('[data-open-drawer]'))) {
        if ($('[data-cart-drawer]')) { e.preventDefault(); openDrawer(); }
        return;
      }
      if (e.target.closest('[data-close-drawer]')) { closeDrawer(); closeModal(); return; }
      if (e.target.closest('[data-close-modal]')) { closeModal(); return; }
      if ((t = e.target.closest('[data-discount-toggle]'))) {
        var panel = $('[data-discount-panel]');
        if (panel) {
          panel.hidden = !panel.hidden;
          t.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
          if (!panel.hidden) { var i = $('[data-discount-input]'); if (i) i.focus(); }
        }
        return;
      }
      if (e.target.closest('[data-discount-apply]')) { applyDiscount(); return; }
      if (e.target.closest('[data-open-nav]')) {
        $('[data-mobile-nav]').classList.add('open');
        document.body.classList.add('no-scroll');
        return;
      }
      if (e.target.closest('[data-close-nav]')) {
        $('[data-mobile-nav]').classList.remove('open');
        document.body.classList.remove('no-scroll');
        return;
      }
      if ((t = e.target.closest('[data-qty-change]'))) {
        e.preventDefault();
        changeLine(parseInt(t.getAttribute('data-line'), 10), parseInt(t.getAttribute('data-qty'), 10));
        return;
      }
      if ((t = e.target.closest('.acc-head'))) {
        var item = t.closest('.acc-item'), panel = item.querySelector('.acc-panel');
        var open = item.classList.toggle('open');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
        t.setAttribute('aria-expanded', open);
        return;
      }
    });

    // Quick add and bundle forms
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-quick-add-form], [data-bundle-form]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Adding…'; }
      addToCart(new FormData(f)).then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeModal(); }
      if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
        e.preventDefault();
        applyDiscount();
      }
    });

    // Collection sort
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    initGallery();
    initProductForm();

    window.addEventListener('scroll', queueSweep, { passive: true });
    window.addEventListener('resize', queueSweep);
    queueSweep();

    fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(updateCounts).catch(function () {});

    if (!popupSeen()) {
      setTimeout(openModal, 22000);
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 12) openModal();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
